import { render } from "./MWUpdateNews.vue?vue&type=template&id=d3898400"
import script from "./MWUpdateNews.vue?vue&type=script&lang=js"
export * from "./MWUpdateNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__